

<script>

	import { onMount } from 'svelte'
	import {
		initNotificacionesController,
		initTicketsController,
		initprofileController,
		initChatController,
		initHelpController,
		signOut,
	} from './controllers.js'

	const buttons = {}

	onMount(() => {

		signOut(buttons.signOut)
		initChatController(buttons.chat)
		initHelpController(buttons.help)
		initprofileController(buttons.profile)
		initTicketsController(buttons.supplierTickets)
		initNotificacionesController(buttons.notifications)
	})

</script>

<section>

	<div class="section-container">

		<a class="button-2" href="https://metrokubiko-control.vercel.app/app/projects">Tableros de control</a>

		<button class="button fas fa-boxes" title="Tickets de proveedores" bind:this={buttons.supplierTickets} ><span /></button>
		<button class="button fas fa-bell" title="Notificaciones" bind:this={buttons.notifications} ><span /></button>
		<button class="button fas fa-comment" title="Chat de metroKUBIKO" bind:this={buttons.chat} ><span /></button>
		<button class="button fas fa-question" title="Ayuda" bind:this={buttons.help} />
		<button class="button fas fa-user" title="Perfil" bind:this={buttons.profile} />
		<a href="../pwa/" target="_blank" title="Descargar App" class="button fas fa-mobile-screen" />
		<button class="button fas fa-power-off" title="Cerrar Sesión" bind:this={buttons.signOut} />

	</div>

</section>



<div class="home-modal-bottom profile-container" style="display: none;">
	<div class="home-modal-bottom__display  profile-container__display">

		<div class="home-modal-bottom__display__title profile-container__display__title">
			<span> Perfil </span>
			<span> <i class="fas fa-times"></i> </span>
		</div>

		<div class="home-modal-bottom__display__body profile-container__display__body"></div>

	</div>
</div>


<div class="home-modal-bottom notifications-container" style="display: none;">
	<div class="home-modal-bottom__display  notifications-container__display">

		<div class="home-modal-bottom__display__title notifications-container__display__title">
			<span> Notificaciones </span>
			<span> <i class="fas fa-times"></i> </span>
		</div>

		<div class="home-modal-bottom__display__body notifications-container__display__body"></div>

	</div>
</div>




<style>

	.section-container {
		justify-content: flex-end;
		align-items: center;
		flex-wrap: wrap;
		display: flex;
		gap: 10px 20px;
		padding: 30px 0px;
	}

	.button-2 {
    background: #ec6712;
    font-size: 1rem;
    border: none;
    border-radius: 5px;
    color: white;
    padding: 5px 15px;
		text-decoration: none;
    box-shadow: 0px 2px 10px 0px #00000070;
	}

	.button {
		text-decoration: none;
		position: relative;
		background: none;
		padding: none;
		border: none;
		transition: color .3s;
		font-size: 1.7rem;
		color: rgba(255, 255, 255, 1);
	}

	.button:hover {
		color: rgb(183, 197, 232);
	}

	.button span {
		position: absolute;
		display: none;
		color: white;
		top: -8px;
		right: -7px;
		padding: 2px 7px;
		font-size: .7rem;
		font-weight: 400;
		border-radius: 5px;
		background-color: #e3165b;
		font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Symbol";
	}


</style>

